const dashboard = {
  breadcrumb: "لوحة التحكم",
  showMore: "عرض المزيد",
  showLess: "عرض أقل",
  header: {
    welcomeBack: "مرحبًا بعودتك، {name}",
    welcomeBackNoName: "مرحبًا بعودتك",
    periodNote: "البيانات المعروضة لآخر 30 يومًا",
    platformOverview: "إليك نظرة عامة على المنصة عبر جميع الشركات اليوم.",
    createEvent: "إنشاء فعالية",
  },
  refresh: {
    action: "تحديث البيانات",
    refreshing: "جارٍ التحديث…",
    justNow: "تم التحديث الآن",
    minutesAgo: "تم التحديث منذ {value} دقيقة",
    hoursAgo: "تم التحديث منذ {value} ساعة",
  },
  stats: {
    delta: "{value} خلال آخر 30 يومًا",
    period: "خلال آخر 30 يومًا",
    admin: {
      totalCompanies: "إجمالي الشركات",
      totalEvents: "إجمالي الفعاليات",
      totalClients: "إجمالي العملاء",
      totalApplicants: "إجمالي المتقدمين",
      totalWorkingHours: "إجمالي ساعات العمل",
      hoursUnit: "{value} ساعة",
      info: {
        totalEvents: "الفعاليات القادمة + الحاليه + المكتملة",
        totalWorkingHours: "الفعاليات المكتملة والحاليه",
      },
      empty: {
        totalCompanies: "لا توجد شركات بعد",
        totalEvents: "لا توجد فعاليات بعد",
        totalClients: "لا يوجد عملاء بعد",
        totalApplicants: "لا يوجد متقدمون بعد",
        totalWorkingHours: "لا توجد ورديات مسجلة",
      },
    },
    company: {
      totalEvents: "إجمالي عدد الفعاليات",
      loyalApplicants: "المتقدمون المميزون",
      saudiApplicants: "المتقدمون السعوديون",
      saudiApplicantsNote: "(الفعاليات المكتملة)",
      pendingApplicantsRequest: "طلبات المتقدمين المعلقة",
      applicantsUnder5Events: "المتقدمون بأقل من 5 فعاليات",
      applicantsUnder5EventsNote: "(فعالية جارية)",
      empty: {
        totalEvents: "لا توجد فعاليات بعد",
        loyalApplicants: "لا يوجد بعد",
        saudiApplicants: "لا توجد فعاليات مكتملة بعد",
        pendingApplicantsRequest: "لا توجد طلبات معلقة",
        applicantsUnder5Events: "لا يوجد متقدمون بعد",
      },
    },
  },
  platformStats: {
    activeCompanies: {
      label: "الشركات النشطة",
      empty: "لا توجد شركات بعد",
    },
    activeEvents: {
      label: "الفعاليات الحاليه",
      empty: "لا توجد فعاليات بعد",
    },
    workingApplicants: {
      label: "متقدمو يُرام",
      empty: "لا يوجد متقدمون بعد",
      joinedEvents: "انضموا إلى فعاليات",
      availableToJoin: "لم ينضموا",
      saudiTag: "سعودي",
    },
    attendanceRate: {
      label: "معدل الحضور الإجمالي",
      info: "الفعاليات الحاليه فقط",
      empty: "لا توجد بيانات حضور بعد",
    },
    lateAndNoShow: {
      label: "التأخير وعدم الحضور",
      info: "الفعاليات الحاليه فقط",
      empty: "لا توجد حالات مسجلة",
    },
  },
  topEventsByActivity: "أهم الفعاليات نشاطًا",
  topEvents: {
    title: "أهم الفعاليات نشاطًا",
    viewEvents: "عرض الفعاليات",
    columns: {
      rank: "#",
      event: "الفعالية",
      applicants: "المتقدمون",
      status: "الحالة",
    },
    empty: {
      title: "لا توجد فعاليات بعد",
      description: "بمجرد إنشاء فعالية، ستظهر هنا مرتبة حسب نشاط المتقدمين.",
    },
  },
  topEventsByApplicants: {
    title: "أهم الفعاليات حسب عدد المتقدمين",
    viewEvents: "عرض الفعاليات",
    columns: {
      rank: "#",
      event: "الفعالية",
      companies: "الشركات",
      applicants: "المتقدمون",
      status: "الحالة",
    },
    activeSince: "نشطة منذ {value}",
    empty: {
      title: "لا توجد فعاليات على المنصة بعد",
      description:
        "بمجرد أن تنشئ إحدى الشركات فعالية، ستظهر هنا مرتبة حسب حجم المتقدمين.",
    },
  },
  platformEvents: {
    title: "إجمالي الفعاليات",
    empty: {
      title: "لا توجد بيانات فعاليات بعد",
      description:
        "سيظهر هنا توزيع حالات الفعاليات على مستوى المنصة بمجرد وجود فعاليات.",
    },
  },
  topCompaniesBySaudiApplicants: {
    title: "أهم الشركات حسب عدد المتقدمين السعوديين",
    viewCompanies: "عرض الشركات",
    columns: {
      rank: "#",
      company: "الشركة",
      events: "الفعاليات",
      saudiApplicants: "المتقدمون السعوديون",
    },
    activeSince: "نشطة منذ {value}",
    empty: {
      title: "لا يوجد نشاط للشركات بعد",
      description:
        "بمجرد أن تبدأ الشركات في تنظيم الفعاليات، ستظهر هنا الأكثر نشاطًا.",
    },
  },
  companiesByStatus: {
    title: "الشركات حسب الحالة",
    totalLabel: "إجمالي الشركات",
    status: {
      approved: "نشطة",
      pending: "بانتظار الموافقة",
    },
    empty: {
      title: "لا توجد شركات مسجلة بعد",
      description:
        "ستظهر هنا حالة الشركات النشطة مقابل بانتظار الموافقة بمجرد انضمام الشركات إلى المنصة.",
      action: "عرض طلبات التسجيل",
    },
  },
  totalEvents: {
    title: "الفعاليات",
    totalLabel: "إجمالي الفعاليات",
    empty: {
      title: "لا توجد فعاليات لعرض تفاصيلها بعد",
      description: "سيظهر هنا توزيع حالات فعالياتك بمجرد إنشاء فعالية.",
    },
  },
  ongoingEvents: {
    title: "بيانات الفعاليات الحاليه",
    viewEvents: "عرض الفعاليات",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    newApplicants: "أقل من 5 فعاليات",
    paymentPeriod: {
      daily: "يومي",
      monthly: "شهري",
    },
    metrics: {
      attendanceRate: "معدل الحضور",
      checkIn: "تسجيل الدخول",
      lateCheckIn: "تسجيل دخول متأخر",
      checkOut: "تسجيل الخروج",
      noShow: "عدم الحضور",
    },
    nationality: {
      label: "توزيع الجنسيات",
      applicantsLabel: "{count} متقدم",
      saudi: "سعودي",
      nonSaudi: "غير سعودي",
    },
    footer: {
      viewTimesheet: "عرض ساعات العمل",
      viewReports: "عرض التقارير",
      openReports: "{count} تقارير مفتوحة",
      noReports: "التقارير المفتوحة: لا يوجد حاليًا",
    },
    empty: {
      title: "لا توجد فعاليات جارية حاليًا",
      description: "بمجرد أن تصبح لديك فعالية جارية، ستظهر بيانات حضورها هنا.",
    },
  },
  satisfaction: {
    title: "رضا العملاء",
    overall: "الرضا العام",
    eventsEvaluated: "{count} فعاليات مُقيَّمة",
    eventsEvaluatedOne: "فعالية واحدة مُقيَّمة",
    basedOn: "استنادًا إلى {count} فعاليات",
    basedOnOne: "استنادًا إلى فعالية واحدة",
    bands: {
      good: "جيد",
      needAttention: "يحتاج انتباه",
      low: "منخفض",
    },
    empty: {
      title: "لا توجد تقييمات بعد",
      description: "لا توجد جولات تقييم مكتملة بعد.",
    },
  },
  quickActions: {
    title: "إجراءات سريعة",
    viewRequests: "عرض الطلبات",
    types: {
      registration: {
        label: "طلبات التسجيل",
        description: "شركات جديدة بانتظار الموافقة",
      },
      profileEdit: {
        label: "طلبات تعديل الملف",
        description: "بانتظار الموافقة أو الرفض",
      },
      demo: {
        label: "طلبات العرض التجريبي",
        description: "مسؤولو شركات بانتظار القرار",
      },
    },
    empty: {
      title: "أنت على اطلاع بكل شيء",
      description:
        "لا توجد طلبات تسجيل أو طلبات تعديل ملف أو طلبات عرض تجريبي بانتظارك الآن.",
    },
  },
  applicantEngagement: {
    title: "تفاعل المتقدمين",
    description:
      "نسبة متقدمي كل شركة الذين عملوا في أقل من 5 فعاليات.",
    viewAllCompanies: "عرض كل الشركات",
    empty: {
      title: "لا توجد بيانات تفاعل متقدمين بعد",
      description:
        "سيظهر هذا التفصيل بمجرد أن يكون لدى الشركات متقدمون يعملون في فعاليات.",
    },
  },
  companySatisfaction: {
    title: "رضا الشركات",
    clients: "{count} عملاء",
    clientsOne: "عميل واحد",
    events: "{count} فعاليات مُقيَّمة",
    eventsOne: "فعالية واحدة مُقيَّمة",
    bands: {
      good: "جيد",
      needAttention: "يحتاج انتباه",
      low: "منخفض",
    },
    viewAllCompanies: "عرض كل الشركات",
    empty: {
      title: "لا توجد تقييمات عملاء على مستوى المنصة",
      description:
        "بمجرد أن يقيّم العملاء فعاليات إحدى الشركات، ستظهر هنا درجات الرضا لكل شركة.",
    },
  },
  recentActivity: {
    title: "سجل النشاط الأخير",
    fullLogs: "السجل الكامل",
    modules: {
      companies: "الشركات",
      companyAccount: "حساب الشركة",
      teamPermissions: "الفريق والصلاحيات",
      clients: "العملاء",
      events: "الفعاليات",
      joiningRequests: "طلبات الانضمام",
      timesheet: "سجل الحضور",
      payroll: "الرواتب",
      evaluations: "التقييمات",
    },
    empty: {
      title: "لا يوجد نشاط بعد",
      description:
        "ستظهر هنا الإجراءات التي تتم على الشركات والفعاليات والطلبات فور حدوثها.",
    },
  },
};
export default dashboard;
